import { IComponentOptions } from "angular";
import { DownloadFileComponentController } from "./controller";

export const vsComponentName = "downloadFileComponent";
export const downloadFileComponentOptions: IComponentOptions = {
  controller: DownloadFileComponentController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    downloadFile: "<",
  },
};
